import {isComplete, markComplete} from "./progress"

function lockQuestion(fieldset, picked) {
  const answer = Number(fieldset.dataset.answer)
  const correct = picked === answer
  fieldset.dataset.state = correct ? "right" : "wrong"
  fieldset.querySelectorAll("[data-learn-choice]").forEach((button) => {
    const index = Number(button.dataset.learnChoice)
    button.disabled = true
    if (index === answer) button.dataset.mark = "good"
    else if (index === picked) button.dataset.mark = "bad"
  })
  const explain = fieldset.querySelector("[data-learn-explain]")
  if (explain) explain.hidden = false
  return correct
}

function answeredCount(root) {
  return root.querySelectorAll("[data-learn-question][data-state]").length
}

function correctCount(root) {
  return root.querySelectorAll("[data-learn-question][data-state='right']").length
}

function finish(root) {
  const total = root.querySelectorAll("[data-learn-question]").length
  const correct = correctCount(root)
  const score = root.querySelector("[data-learn-score]")
  if (score) score.textContent = `You got ${correct} of ${total}.`
  const retry = root.querySelector("[data-learn-retry]")
  if (retry) retry.hidden = false
  if (!total || correct < Math.min(2, total)) return
  const slug = root.dataset.lessonSlug
  markComplete(slug)
  const done = root.querySelector("[data-learn-quiz-done]")
  if (done) done.hidden = false
  document.dispatchEvent(new CustomEvent("learn:complete", {detail: {slug}}))
}

function reset(root) {
  root.querySelectorAll("[data-learn-question]").forEach((fieldset) => {
    delete fieldset.dataset.state
    fieldset.querySelectorAll("[data-learn-choice]").forEach((button) => {
      button.disabled = false
      delete button.dataset.mark
    })
    const explain = fieldset.querySelector("[data-learn-explain]")
    if (explain) explain.hidden = true
  })
  const score = root.querySelector("[data-learn-score]")
  if (score) score.textContent = ""
  const retry = root.querySelector("[data-learn-retry]")
  if (retry) retry.hidden = true
  const done = root.querySelector("[data-learn-quiz-done]")
  if (done) done.hidden = true
}

export function mount(root) {
  const slug = root.dataset.lessonSlug
  const prior = root.querySelector("[data-learn-already]")
  if (prior) prior.hidden = !isComplete(slug)
  const retry = root.querySelector("[data-learn-retry]")
  if (retry) retry.hidden = true
  root.querySelectorAll("[data-learn-choice]").forEach((button) => {
    button.addEventListener("click", () => {
      const fieldset = button.closest("[data-learn-question]")
      if (!fieldset || fieldset.dataset.state) return
      lockQuestion(fieldset, Number(button.dataset.learnChoice))
      const total = root.querySelectorAll("[data-learn-question]").length
      if (answeredCount(root) === total) finish(root)
    })
  })
  root.querySelector("[data-learn-retry]")?.addEventListener("click", () => reset(root))
}
